'use client';
function getFloatingPosition(dir, position) {
    if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
        var _position_split = position.split("-"), side = _position_split[0], placement = _position_split[1];
        var flippedPosition = side === "right" ? "left" : "right";
        return placement === undefined ? flippedPosition : flippedPosition + "-" + placement;
    }
    return position;
}

export { getFloatingPosition };
